const setupWebViewJavascriptBridge = () => {
    if (window.ccmsBridge) {
        return;
    }

    function setupWebViewJavascriptBridge(callback) {
        if (window.WebViewJavascriptBridge) {
            return callback(WebViewJavascriptBridge);
        } else {
            document.addEventListener(
                'WebViewJavascriptBridgeReady',
                function () {
                    // 延迟发送autobridge的信息，否则android手机偶尔收不到相应的信息。
                    setTimeout(() => {
                        callback(WebViewJavascriptBridge);
                    }, 0);
                },
                false,
            );
        }

        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
    }

    setupWebViewJavascriptBridge((bridge) => {
        window.ccmsBridge = bridge;
    });
};

function getElement(el) {
    return document.querySelector(el);
}

function getParamsData(parasName) {
    const url = new URLSearchParams(window.location.search);
    return url.get(parasName);
}

export { setupWebViewJavascriptBridge, getElement, getParamsData };
